import React from "react";
import { Container, Row, Col } from "reactstrap";
import VideoFeaturedList from "./VideoFeaturedList";

const Videos = () => {
  return (
    <Container fluid className="p-0">
      <h1 className="page-title">Featured videos</h1>
      <Row>
        <Col lg="12" className="d-flex">
          <VideoFeaturedList />
        </Col>
      </Row>
    </Container>
  );
};

export default Videos;
